import {DashboardStateModel} from '@store/dashboard/dashboard-state.model';
import {Action, State, StateContext, Store} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {
  FetchMetrics,
  FetchOfflineDevicesSummary
} from '@store/dashboard/dashboard.actions';
import {Observable} from 'rxjs';
import {UserService} from '@services/user/user.service';
import {finalize, tap} from 'rxjs/operators';
import {IMetrics} from '@interfaces/metrics';
import {
  ToggleMetricsLoader,
  ToggleOfflineDevicesSummaryLoader
} from '@store/loader';
import {AnalyticsService} from '@services/analytics/analytics.service';
import {IOfflineDevicesSummary} from '@interfaces/analytics';

@State<DashboardStateModel>({
  name: 'dashboardState',
  defaults: {
    devices: null,
    offlineDevicesSummary: null,
    storage: null
  }
})
@Injectable()

export class DashboardState {
  constructor(
    private userService: UserService,
    private analyticsService: AnalyticsService,
    private store: Store
  ) {
  }

  @Action(FetchOfflineDevicesSummary)
  fetchOfflineDevicesSummary(
    ctx: StateContext<DashboardStateModel>
  ): Observable<IOfflineDevicesSummary> {
    this.store.dispatch(new ToggleOfflineDevicesSummaryLoader(true));

    return this.analyticsService.getOfflineDevicesSummary()
      .pipe(
        tap(offlineDevicesSummary => ctx.patchState({offlineDevicesSummary})),
        finalize(() => this.store.dispatch(new ToggleOfflineDevicesSummaryLoader(false)))
      );
  }

  // Actions
  @Action(FetchMetrics)
  fetchMetrics(ctx: StateContext<DashboardStateModel>): Observable<any> {
    this.store.dispatch(new ToggleMetricsLoader(true));
    return this.userService.getCompanyMetrics()
      .pipe(
        tap((metrics: IMetrics) => {
          const state = ctx.getState();
          ctx.setState({
            ...state,
            storage: metrics.storage,
            devices: metrics.devices,
          });
          this.store.dispatch(new ToggleMetricsLoader(false));
        })
      );
  }

}
